/**
 * Do not edit directly
 * Generated on Fri, 25 Nov 2022 14:07:59 GMT
 */
export var light = "300";
export var normal = "400";
export var medium = "500";
export var semiBold = "600";
export var bold = "700";
export var book = "400";
//# sourceMappingURL=font-weights.js.map